import React, { useEffect, useState } from 'react';
import { ChevronRight, Plus } from 'lucide-react';
import { Button } from '@/components/shadcn-ui/button';
import { Link, useNavigate } from 'react-router-dom';
import { Input } from '@/components/shadcn-ui/input';
import { cn } from '@/lib/utils';
import { useEstateStore } from '@/stores/useEstate.store';
import { getEstates } from '@/network/api.service';

const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

const EstatesPage = () => {
  const estates = useEstateStore(state => state.estates);
  const setEstates = useEstateStore(state => state.setEstates);

  const navigate = useNavigate();
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    const fetchEstates = async () => {
      try {
        const response = await getEstates();
        if (response?.data?.data) {
          setEstates(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching estates:', error);
      }
    };

    fetchEstates();
  }, [setEstates]);

  useEffect(() => {
    // Redirect to add estate when the list is loaded and empty.
    if (Array.isArray(estates) && estates.length === 0) {
      setRedirecting(true);
      navigate('/estates/add', { replace: true });
    }
  }, [estates, navigate]);

  if (redirecting) {
    return null;
  }

  return (
    <div className="relative flex h-full w-full flex-col bg-white">
      {/* Search */}
      <div className="w-full border-b bg-white px-3 py-2">
        <input placeholder="Search users..." className="my-1 w-full px-1 outline-none" />
      </div>

      {/* List + A–Z index */}
      <div className="mt-1 flex w-full overflow-y-auto bg-white">
        <div className="ml-4 mr-1 h-full flex-1 overflow-y-auto">
          {estates?.map((est, idx) => (
            <Link
              to={`detail/${est._id}`}
              key={est._id}
              className={cn(
                'flex w-full items-center justify-between border-b-2 border-[#E1E1E1FF] py-4 text-sm',
                idx === estates.length - 1 && 'border-b-0'
              )}
            >
              <div className="flex items-center gap-1 font-medium">
                <span>{est.name}</span>
                {est?.estate_code && <span>({est?.estate_code})</span>}
              </div>
              <ChevronRight className="h-5 w-5 text-zinc-500" />
            </Link>
          ))}
        </div>

        {/* A–Z index */}
        <div className="pointer-events-none flex w-8 flex-col items-center justify-center pt-4">
          {alphabet.map(ch => (
            <span key={ch} className="mb-1 text-xs font-medium uppercase text-gray-400">
              {ch}
            </span>
          ))}
        </div>
      </div>

      {/* Floating add button */}
      <Link to="/estates/add" className="fixed bottom-16 right-4">
        <button className="flex h-14 w-14 cursor-pointer items-center justify-center rounded-full border border-white/30 bg-black text-white shadow-xl">
          <Plus size={24} />
        </button>
      </Link>
    </div>
  );
};

export default EstatesPage;

// const Layout = ({ children }) => (
//   // <div className="">

//   //   {children}

//   //   {/* <Link to="/estates/add" className="absolute bottom-0 right-0">
//   //     <Button className="h-14 w-14 rounded-full shadow-xl bg-black text-white border border-white/30">
//   //       <Plus className="h-6 w-6" />
//   //     </Button>
//   //   </Link> */}
//   // </div>
// );
